<template>
    <div class='alert-holder ee'>
        <v-alert
		        type="error"
		        class="alertComponent"
        >
	        <div v-html="dataWarn.message"></div>
        </v-alert>
    </div>
</template>

<script>
export default {
	name: "Warning",
	props: {
		dataWarn: Object
	},
	data() {
		return {
			type: ''
		};
	}
};
</script>

<style scoped>

body .alert-holder {
	position: fixed;
	bottom: 20px;
	left: 20px;
	z-index: 99999999999 !important;
	pointer-events: none;
	max-width: calc(100% - 40px);

	min-width: 290px;
	.alertComponent {
		&::after {
			content: '';
			position: absolute;
			bottom: 0;
			left: 0;
			height: 4px;
			width: 0;
			background-color: rgba(28, 28, 40, 0.2);
			animation: fillBar 4s forwards;
		}
	}
}

@keyframes fillBar {
	to {
		width: 100%;
	}
}

</style>
